import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// Design tokens FIRST (generated from tokens/tokens.json — the single source of truth),
// then global styles which consume them.
import './styles/tokens.generated.css'
import './index.css'
import App from './App.jsx'

// Block old Firebase domains and enforce official domain
// (Skips Tauri desktop app which runs on tauri.localhost)
const LEGACY_DOMAINS = ['alphafocus-ed7f0.web.app', 'alphafocus-ed7f0.firebaseapp.com'];
if (LEGACY_DOMAINS.includes(window.location.hostname)) {
    window.location.replace(`https://app.alphafocus.app${window.location.pathname}${window.location.search}${window.location.hash}`);
}

// Tauri App: Forcefully unregister any lingering Service Workers 
// to prevent cached HTML from blocking new updates (fixes CTRL+SHIFT+R issue)
setTimeout(() => {
    if (window.__TAURI_INTERNALS__ && 'serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then(registrations => {
            for (let registration of registrations) {
                registration.unregister();
                console.log('[Tauri] Unregistered legacy service worker to ensure fresh updates.');
            }
        });
    }
}, 50);

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
